import React,{useState,useEffect} from 'react'
import logo from '../Assets/logo2.png'
import { IoIosMenu } from "react-icons/io";
import classes from './Header.module.css'
import axios from 'axios'
import { fetch_data } from '../Services/api';
import { Link, useParams } from 'react-router-dom';
import SidebarComponent from './SideBarComponent';

const Header = () => {

  const {category} = useParams()

  console.log(category)

  const [sidebar,setSidebar] = useState(false)

  const handleIconClick=()=>{
    setSidebar(!sidebar)
  }

  const [categories,setCategories] = useState([])
  // const [loading,setLoading] = useState(false);

  const fetchData=async()=>{
      // setLoading(true);
      const res = await axios.get(fetch_data);
     console.log(res.data.categories)
      setCategories(res.data.categories)
      // setLoading(false);
  }

  useEffect(() => {
      fetchData();
  }, [])


  return (
    <div className={classes.container}>
      <div className={classes.logo}>
      <img src={logo} alt="" className={classes.img} />
      {/* Kidoffy */}
      </div>
      <div className={classes.categories}>
      <Link to={`/` } style={{textDecoration:'none'}}>
      <p className={`${classes.category} ${category == undefined && classes.active}`}>
            Home
            </p>
            </Link>
      {
        categories && 
        categories?.map((item)=>(
          <>
          <Link to={`/Category/${item.id}` } style={{textDecoration:'none'}}>
            <p className={`${classes.category} ${category == item.id && classes.active}`}>
            {item.name}
            </p>
            </Link>
          </>
        ))
      }
      </div>

      <div className={classes.menuBar}>
      <IoIosMenu style={{cursor:'pointer'}} onClick={handleIconClick}/>
      </div>
<SidebarComponent visible={sidebar} handle={handleIconClick} categories={categories}/>
    </div>
  )
}

export default Header
